
const initArticleSearch = () => {
  const articleContainer = document.querySelector("#article-filter-container");

  if (!articleContainer) {
    return;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const articleRestBase = protocol + '//' + hostname + '/wp-json/article-rest/v1';
  const searchButton = document.querySelector('#search-article');
  const clearBtn = document.querySelector('#clear-article-search');
  const noResultsMessage = document.querySelector('#no-results-message');
  const categorySearch = document.querySelectorAll('.category-btn');
  const pagination = document.querySelector('.pagination');
  
  // GET ARTICLE RESULTS
  const getArticleResults = (category, keywords) => {

    let data = {
      'action' : 'article_rest',
      category: category,
      keywords: keywords
    };
    
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'X-WP-Nonce': article_rest.apiNonce,
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        data: data,
      }),
    };

    fetch(articleRestBase + '/search?date=' + Date.now(), options)
      .then((response) => {
        if (!response.ok) {
          const statusError = 'Error getting Search from API';
          if (response.status === 403) {
            console.log('Nonce Error');
          }
          throw new Error(statusError);
        } else {
          return response.json();
        }
      })
      .then((response) => {
        if (response && response.posts !== '') {
          articleContainer.innerHTML = response.posts;
          noResultsMessage.style.display = 'none';
          pagination.style.display = 'none';
        } else {
          articleContainer.innerHTML = '';
          noResultsMessage.style.display = 'block';
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  categorySearch.forEach(button => {
    button.addEventListener("click", () => {
      let selectedCategory = button.dataset.id;

      categorySearch.forEach(btn => btn.classList.remove('selected'));
      button.classList.add('selected');

      let keywords = document.querySelector('.search-input').value;

      getArticleResults(selectedCategory, keywords);
      clearBtn.style.display = 'inline-block';
    });
  });

  if (searchButton) {
    searchButton.addEventListener("click", () => {
        let selectedCategory = document.querySelector('.category-btn.selected') ? document.querySelector('.category-btn.selected').dataset.id : '';
        let keywords = document.querySelector('.search-input').value;

        getArticleResults(selectedCategory, keywords);
        clearBtn.style.display = 'inline-block';
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      document.querySelector('.search-input[name="search-input"]').value = '';

      categorySearch.forEach(btn => btn.classList.remove('selected'));

      clearBtn.style.display = 'none';

      getArticleResults('', '');
    });
  }
};

export default initArticleSearch;
